export default "__VITE_ASSET__fhn2JJnv__"